@for (pill of visiblePills; track pill.key) {
  <button
    type="button"
    class="product-pill"
    [class]="pill.content.pillClasses"
    (click)="onPillClick($event, pill.content)"
  >
    <fa-icon [icon]="pill.content.icon ?? faBolt" class="product-pill__icon" aria-hidden="true"></fa-icon>
    <span>{{ pill.content.label }}</span>
  </button>
}
